import { render, staticRenderFns } from "./DataManipulationGuide.vue?vue&type=template&id=36b50c84&scoped=true"
import script from "./DataManipulationGuide.vue?vue&type=script&lang=js"
export * from "./DataManipulationGuide.vue?vue&type=script&lang=js"
import style0 from "./DataManipulationGuide.vue?vue&type=style&index=0&id=36b50c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b50c84",
  null
  
)

export default component.exports